import { CalendarEventType } from './calendar-event-type';
import { Country } from './country';

export class CalendarFilter {
  countries?: Country[];
  topicGroups?: CalendarEventType[];

  constructor(
    countries: Country[] = [],
    topicGroups: CalendarEventType[] = [],
  ) {
    (this.countries = countries),
      (this.topicGroups = topicGroups);
  }

  description = (): string => {
    let countryString = '';
    let topicString = '';
    if (this.countries?.length) {
      countryString = this.countries.map((c) => c.name).join(', ');
    } else {
      countryString = 'All countries';
    }
    if (this.topicGroups?.length) {
      topicString = this.topicGroups.map((t) => t.name).sort().join(', ');
    } else {
      topicString = 'All topics';
    }
    return [countryString, topicString].join(' | ');
  };
}
